/**
 * 로그인한 사용자 이름만 기억한다(로컬 IndexedDB 이름이 사용자별 — db.ts).
 * 인증 자체는 중앙 세션 쿠키(thuthi_session, .thuthi.kr)가 하고 /api/v2 는 nginx 가 확인한다 —
 * 예전 ntfy tk_ 토큰은 더 쓰지 않는다. 이름은 /login(중앙 세션 브리지)이 채운다.
 */
class Session {
  store(username: string) {
    localStorage.setItem("user", username);
    localStorage.removeItem("token"); // 옛 ntfy 토큰 흔적
  }

  async resetAndRedirect(url: string) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    window.location.href = url;
  }

  exists() {
    return !!this.username();
  }

  username() {
    return localStorage.getItem("user");
  }
}

const session = new Session();
export default session;
